// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3IsxZ","col":"Table_col__3R6wB","fulfillmentStatus":"Table_fulfillmentStatus__2GyAt","emailCol":"Table_emailCol__gCuN-"};